import { useParams } from "react-router-dom";
import { Loading, Error } from "ra-ui-materialui";
import { useTranslate } from "react-admin";

import useOneMember from "../../../hooks/useOneMember";
import useOneMemberCI from "../../../hooks/useOneMemberCI";
import MemberProfileBaseView from "../components/MemberProfileBaseView";
import useAddressInfo from "../../../hooks/useAddressInfo";
import useOccupations from "../../../hooks/useOccupations";
import { getFieldBlock } from "../../../helper/FormBlockHelper";
import { useLocale } from "react-admin";

const GeneralInfoView = () => {
  const { id } = useParams();
  const locale = useLocale();
  const translate = useTranslate();
  const {
    member: ci,
    form,
    loading: ciLoading,
    error: ciError,
  } = useOneMemberCI(id);
  const { member, loading, error } = useOneMember(id);

  const {
    subDistricts,
    districts,
    provinces,
    postcodes,
    loading: addressLoading,
    error: addressError,
  } = useAddressInfo();
  const {
    occupations,
    loading: occupationLoading,
    error: occupationError,
  } = useOccupations();
  if (loading || ciLoading || addressLoading || occupationLoading)
    return <Loading />;
  if (error || ciError || addressError || occupationError)
    return <Error error={error} />;

  const blockListData = form.fields
    .map((f) =>
      getFieldBlock({
        field: f,
        occupations,
        provinces,
        subDistricts,
        postcodes,
        districts,
        lang: locale,
      })
    )
    .filter((data) => data !== null);

  const addedValueBlockData = blockListData.map((data) => ({
    ...data,
    value: ci[data.key],
  }));

  const PERSONAL_INFO_DATAS = [
    "firstname",
    "lastname",
    "nickname",
    "birthdate",
  ];
  const UNTITLED_INFO_DATAS = [
    "nationality",
    "gender",
    "state",
    "occupation_id",
  ];
  const CONTACT_INFO_DATAS = [
    "phone",
    "email",
    "line_id",
    "instagram_id",
    "address",
    "province_id",
    "district_id",
    "sub_district_id",
    "postcode_id",
  ];

  const personalDatas = PERSONAL_INFO_DATAS.map((DATA) => {
    return addedValueBlockData.find((data) => data.key === DATA);
  });

  const untitledDatas = UNTITLED_INFO_DATAS.map((DATA) => {
    return addedValueBlockData.find((data) => data.key === DATA);
  });
  const contactDatas = CONTACT_INFO_DATAS.map((DATA) => {
    return addedValueBlockData.find((data) => data.key === DATA);
  });

  const testTab = [
    {
      title: translate("ra.text.General_information"), //General_information
      blocks: [
        {
          title: translate("ra.text.ci.generalInformation.personasInformation"),
          isArray: false,
          datas: personalDatas,
        },
        {
          title: "",
          isArray: false,
          datas: untitledDatas,
        },
        {
          title: translate("ra.text.ci.generalInformation.contact"),
          isArray: false,
          datas: contactDatas,
          address: true,
        },
        {
          title: translate("ra.text.ci.generalInformation.memberCode"),
          isArray: false,
          noEdit: true,
          datas: [{ key: "code", value: ci.code, text: "Code", type: "text" }],
        },
      ],
    },
  ];

  return (
    <MemberProfileBaseView
      title={translate("ra.text.General_information")}
      tabs={testTab}
      member={member}
      ci={ci}
      address
    />
  );
};

export default GeneralInfoView;
